import firebase from '../../../core/config/firebase';

const auth = firebase.auth();

export const getUser = () => auth?.currentUser;
